import { CommitteeModelInterface } from "@api/models/interfaces/committees/CommitteeModelInterface";
import { Element } from "@api/models/Element";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { DateTime } from "luxon";
import { ElementInterface } from "@api/models/interfaces/ElementInterface";
import { CompanyWithParentsInterface } from '../interfaces/CompanyWithParentsInterface';

class CommitteeModelBase extends Element {
    title: string;
    description?: string;
    userIds: number[];
    ticketIds: string[];
    beginAt: DateTime;
    endAt: DateTime;
    subjectType: TicketType;
    location?: string;
    link?: string;
    summary?: string;
    ticketsData?: object;
    secretary: number;
    protocolFileId?: string;
    isClosed?: boolean;

    constructor(data: ElementInterface, schema = '', datesFields: string[]) {
        super(data, schema, datesFields);
    }
}

/**
 * This model for Committee item which contains ref collection @company
 */
export class CommitteeModelExtended extends CommitteeModelBase {
    company: CompanyWithParentsInterface<string>;
    constructor(data: ElementInterface, schema = "") {
        super(data, schema, ['beginAt', 'endAt']);
    }
}

export class CommitteeModel extends CommitteeModelBase {
    company: CompanyWithParentsInterface<string>;
    constructor(data: ElementInterface, schema = "") {
        super(data, schema, ['beginAt', 'endAt']);
    }
}
